import { useState } from "react";

import { theme } from "@/core/theme";
import Menu, { Button } from "@/tpo/Menu";
import Stack from "@/tpo/Stack";
import ButtonV2 from "@/v2/Buttons";

const ITEM_SX = {
  borderRadius: 0,
  justifyContent: "flex-start",
  gap: 10,
  padding: "5px 0px 5px 10px",
  height: "auto"
};

export default function LegacyResponsiveSideNavigation({
  links,
  desktopProps,
  mobileDropdownProps
}) {
  const [menuOpen, setMenuOpen] = useState(false);
  const activeLink = links.find(link => link.active);

  return (
    <>
      <Menu opened={menuOpen} onChange={setMenuOpen} trigger="hover">
        <Menu.Target>
          <Button
            sx={{ display: ["flex", "flex", "none"] }}
            open={menuOpen}
            fullWidth
            lineHeight="24px"
            paddingY="16px"
            paddingX="40px"
            maxWidth={[null, 353]}
          >
            {activeLink?.label}
          </Button>
        </Menu.Target>
        <Menu.Dropdown as={Stack} mt={2} py={40} px={40} zIndex={2} {...mobileDropdownProps}>
          {links.map(({ key, label, active, disabled, onClick, renderIcon }) => (
            <ButtonV2
              leftIcon={renderIcon?.({ disabled })}
              sx={{
                borderLeft: active ? `3px solid ${theme.colors.purple}` : "3px solid transparent",
                color: disabled ? theme.colors.carbon : theme.colors.dark,
                textAlign: "left",
                whiteSpace: "normal",
                lineHeight: "1.8",
                ...ITEM_SX
              }}
              key={key || label}
              disabled={disabled}
              onClick={onClick}
            >
              {label}
            </ButtonV2>
          ))}
        </Menu.Dropdown>
      </Menu>
      <Stack
        display={["none", "none", "flex"]}
        bg="white"
        borderRadius={5}
        pt={60}
        pb={80}
        px={40}
        mb="auto"
        minWidth={310}
        maxWidth={310}
        {...desktopProps}
      >
        {links.map(({ key, label, active, disabled, onClick, renderIcon }) => (
          <ButtonV2
            leftIcon={renderIcon?.({ disabled })}
            sx={{
              borderLeft: active ? `3px solid ${theme.colors.purple}` : "3px solid transparent",
              color: disabled ? theme.colors.carbon : theme.colors.dark,
              textAlign: "left",
              whiteSpace: "normal",
              lineHeight: "1.8",
              ...ITEM_SX
            }}
            key={key || label}
            disabled={disabled}
            onClick={onClick}
          >
            {label}
          </ButtonV2>
        ))}
      </Stack>
    </>
  );
}

LegacyResponsiveSideNavigation.defaultProps = {
  desktopProps: {},
  mobileDropdownProps: {}
};
